import { gql, TypedDocumentNode } from "@apollo/client";

import { QueryMetricsRangeArgs, SpaceliftMetrics } from "types/generated";

type GetTimeToRecoveryRangeData = {
  metricsRange: Pick<SpaceliftMetrics, "averageTimeToRecoveryRange" | "hasRuns">;
};

export const GET_TIME_TO_RECOVERY_RANGE: TypedDocumentNode<
  GetTimeToRecoveryRangeData,
  QueryMetricsRangeArgs
> = gql`
  query GetTimeToRecoveryRange($input: MetricsInput) {
    metricsRange(input: $input) {
      averageTimeToRecoveryRange {
        value
        timestamp
      }
      hasRuns
    }
  }
`;
